<template>
  <page :manualInit="privilege.init" :manualErr="privilege.initErr" @reload="doInit">
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
export default {
  data() {
    return {

    }
  },
  computed: {
    privilege() {
      return this.$store.state.adminUser.privilege
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('privilegeInit')
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style>

</style>
